import trekzyLogo from '../../assets/images/trekzy-logo2.svg'
import toursprivados from '../../assets/images/toursprivadosbytrekzy-logo-white.png'
import Header2 from '../Header2'
import Footer2 from '../Footer2'
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

const CheckoutLayout = ({ children }) => {
    const { i18n } = useTranslation();
    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header2 logoImgSource={i18n.language == 'es' ? toursprivados : trekzyLogo} logoWidth={i18n.language == 'es' ? '15rem' : '8rem'} />
            <Box sx={{ flex: 1 }}>
                {children}
            </Box>
            <Footer2 />
        </Box>
    )
}

export default CheckoutLayout
